import domReady from '@wordpress/dom-ready';
import $ from 'jquery';

domReady(() => {
  const items = $('.sidebar-navigation__list__item');
  const sidebarToggle = document.querySelector('#sidebar-navigation-toggle');
  const sidebarContent = document.querySelector('#sidebar-navigation-content');

  if (sidebarToggle && sidebarContent) {
    sidebarToggle.addEventListener('click', () => {
      if (sidebarContent.classList.contains('expanded')) {
        sidebarContent.classList.remove('expanded');
        sidebarToggle.setAttribute('aria-expanded', 'false');
      } else {
        sidebarContent.classList.add('expanded');
        sidebarToggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function syncFirstLevelToggleIcon(item, isOpen) {
    const toggle = item
      .children('.sidebar-navigation__list__link-wrapper')
      .children('.sidebar-navigation__list__item__toggle');

    if (!toggle.length || !item.hasClass('depth-0')) {
      return;
    }

    toggle.find('span').toggleClass('fa-plus', !isOpen);
    toggle.find('span').toggleClass('fa-minus', isOpen);
  }

  function openItem(item) {
    const siblingItems = item.siblings();
    const linkWrapper = item.children(
      '.sidebar-navigation__list__link-wrapper'
    );
    const toggle = linkWrapper.children(
      '.sidebar-navigation__list__item__toggle'
    );
    const content = item.children('.sidebar-navigation__list__item__children');

    content.slideDown();
    item.addClass('opened');
    toggle.attr('aria-expanded', 'true');
    syncFirstLevelToggleIcon(item, true);

    // close siblings
    siblingItems.each(function () {
      const siblingWrapper = $(this).children(
        '.sidebar-navigation__list__link-wrapper'
      );
      const siblingToggle = siblingWrapper.children(
        '.sidebar-navigation__list__item__toggle'
      );
      const siblingContent = $(this).children(
        '.sidebar-navigation__list__item__children'
      );
      $(this).removeClass('opened');
      siblingContent.slideUp();
      siblingToggle.attr('aria-expanded', 'false');
      syncFirstLevelToggleIcon($(this), false);
    });
  }

  function closeItem(item) {
    const linkWrapper = item.children(
      '.sidebar-navigation__list__link-wrapper'
    );
    const toggle = linkWrapper.children(
      '.sidebar-navigation__list__item__toggle'
    );
    const content = item.children('.sidebar-navigation__list__item__children');
    const childItems = item.find('.sidebar-navigation__list__item');

    content.slideUp();
    item.removeClass('opened');
    toggle.attr('aria-expanded', 'false');
    syncFirstLevelToggleIcon(item, false);

    // close all children
    childItems.each(function () {
      const childWrapper = $(this).children(
        '.sidebar-navigation__list__link-wrapper'
      );
      const childToggle = childWrapper.children(
        '.sidebar-navigation__list__item__toggle'
      );
      const childContent = $(this).children(
        '.sidebar-navigation__list__item__children'
      );
      $(this).removeClass('opened');
      childContent.slideUp();
      childToggle.attr('aria-expanded', 'false');
      syncFirstLevelToggleIcon($(this), false);
    });
  }

  if (items) {
    items.each(function () {
      const item = $(this);
      const linkWrapper = item.children(
        '.sidebar-navigation__list__link-wrapper'
      );
      const toggle = linkWrapper.children(
        '.sidebar-navigation__list__item__toggle'
      );

      if (item.hasClass('active') || item.hasClass('parent-active')) {
        openItem(item);

        // Open all parent ancestors
        let parent = item
          .closest('.sidebar-navigation__list__item__children')
          .parent();
        while (
          parent.length &&
          parent.hasClass('sidebar-navigation__list__item')
        ) {
          if (!parent.hasClass('opened')) {
            parent.addClass('opened');
            const parentLinkWrapper = parent.children(
              '.sidebar-navigation__list__link-wrapper'
            );
            const parentToggle = parentLinkWrapper.children(
              '.sidebar-navigation__list__item__toggle'
            );
            const parentContent = parent.children(
              '.sidebar-navigation__list__item__children'
            );
            parentContent.slideDown();
            parentToggle.attr('aria-expanded', 'true');
            syncFirstLevelToggleIcon(parent, true);
          }
          parent = parent
            .closest('.sidebar-navigation__list__item__children')
            .parent();
        }
      }

      toggle.on('click', function () {
        if (item.hasClass('opened')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }
});
